<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        ref="searchItem"
        :show-more-scheme="true"
        :show-simple="true"
        :expand-adv="false"
        search-item-code="付款申请-思锐列表查询"
        config-module="5081"
        :grid-config-module="configModel"
        :custom-search-items="customSearchItems"
        @query="fetchData"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <template slot="operations">
          <div v-if="source === 'unSubmitted'" class="triggers">
            <el-button no="1" type="primary" @click="viewBillPaymentDetail">{{ $t('Payment.viewDetails_SR') }}</el-button>
            <el-button no="2" type="primary" @click="createBillPayment">{{ $t('Payment.newPaymentRequest_SR') }}</el-button>
            <el-button no="3" type="primary" @click="deleteBillPayment">{{ $t('Payment.deletePaymentRequest_SR') }}</el-button>
            <el-button no="4" type="primary" :disabled="canSendWeaver" @click="commitBillPayment">{{ $t('Payment.sendWeaver_SR') }}</el-button>
            <!-- <el-button no="5" type="primary" @click="toPrint">{{ $t('Payment.print') }}</el-button> -->
            <el-dropdown
              no="5"
              split-button
              type="primary"
              style="margin: 0 5px;"
              @click="toPrint($t('Payment.print'))"
              @command="toPrint"
            >
              {{ $t('Payment.print') }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('Clearing.PrintByPaymentRequestNumber')">{{ $t('Clearing.PrintByPaymentRequestNumber') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-if="source === 'approving'" class="triggers">
            <el-button no="6" type="primary" @click="viewBillPaymentDetail">{{ $t('Payment.viewDetails_SR') }}</el-button>
            <!-- <el-button no="7" type="primary" @click="toPrint">{{ $t('Payment.print') }}</el-button> -->
            <el-dropdown
              no="7"
              split-button
              type="primary"
              style="margin: 0 5px;"
              @click="toPrint($t('Payment.print'))"
              @command="toPrint"
            >
              {{ $t('Payment.print') }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('Clearing.PrintByPaymentRequestNumber')">{{ $t('Clearing.PrintByPaymentRequestNumber') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-if="source === 'approved'" class="triggers">
            <el-button no="8" type="primary" @click="viewBillPaymentDetail">{{ $t('Payment.viewDetails_SR') }}</el-button>
            <!-- <el-button no="9" type="primary" @click="toPrint">{{ $t('Payment.print') }}</el-button> -->
            <el-dropdown
              no="9"
              split-button
              type="primary"
              style="margin: 0 5px;"
              @click="toPrint($t('Payment.print'))"
              @command="toPrint"
            >
              {{ $t('Payment.print') }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('Clearing.PrintByPaymentRequestNumber')">{{ $t('Clearing.PrintByPaymentRequestNumber') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </search-item>

      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModel"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          :config-module="configModel"
          :page-sizes="[5,6,7,8,10,20,30,50,100,500]"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="queryPageHandler"
        />
      </div>

      <!--付款申请详情-->
      <bill-payment-detail
        v-if="billPaymentDetailProperties.visible"
        :bill-payment-uuid="billPaymentDetailProperties.uuid"
        :title="billPaymentDetailProperties.title"
        :visible.sync="billPaymentDetailProperties.visible"
        :state="billPaymentDetailProperties.state"
        :open-sap-config="context.openSapConfig"
        :charges="billPaymentDetailProperties.charges"
        :charges-dirty="billPaymentDetailProperties.chargesDirty"
        :bill-payment-dirty="billPaymentDetailProperties.billPaymentDirty"
        :input-by="billPaymentDetailProperties.inputBy"
        :parent-context="context"
        :location="location"
        @reflushRowData="reflushRowData($event)"
        @toPreStep="toPreStep"
      />
      <!-- 创建付款申请 选择费用-->
      <new-bill-pay-ment-dialog
        v-if="createNewDialog.visible"
        :visible="createNewDialog.visible"
        :title="createNewDialog.title"
        :bill-payment-account-id="createNewDialog.accountId"
        :view-source="createNewDialog.source"
        :bill-payment-uuid="createNewDialog.uuid"
        :default-conditions="addChargeCondition"
        @close="createNewDialog.visible=false"
      />
      <!-- 打印报表对话框 -->
      <cargo-template-selector-dialog
        :visible.sync="templateSelectorDialog.visible"
        :ctx="templateSelectorDialog.cxt"
        :category="templateSelectorDialog.category"
        :data="templateSelectorDialog.data"
        :context="context"
        :pre-print-callback="prePrintCallback"
        :printed-callback="printedCallback"
        :v2-check-callback="v2CheckCallback"
      />
      <!--开票-->
      <make-invoice-dialog ref="invoice" :location="location" />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { DocumentManage, ensureExecuteSuccess } from '@/utils/commonUtil'
import BillingPaymentHp from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/js/billingPaymentHp'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import lodash from 'lodash'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import billPaymentDetail from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/billPaymentDetail'
import newBillPayMentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/newBillPayMentDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { BillPayment } from '@/class/model/act/BillPayment'
import { getGridSelected } from '@/utils/agGrid'
import { cacheName, cache } from '@/utils/cacheManager'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import TemplateManagement from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/templateManagement'
import { LOG_BILL_PAYMENT } from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

/**
 * 包含运行时用到的基础数据
 */
class Context {
  constructor() {
    this.loading = false
    this.user = null
    this.officeList = null
    this.office = null
    this.config = null
    this.openSapConfig = false
    cache.load(cacheName.USER, cacheName.OFFICE_LIST, cacheName.CONFIG).then(() => {
      this.user = cache.user
      this.officeList = cache.officeList
      this.config = cache.config
      this.openSapConfig = Number(cache.config.get('openSapConfig')) === 1
    })
  }
  /**
   * 准备好数据
   */
  async prepareData() {
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.config = cache.config
  }
}

export default {
  name: 'TabBillPaymentList',
  components: {
    TemplateManagement,
    searchItem,
    newBillPayMentDialog,
    billPaymentDetail,
    cargoTemplateSelectorDialog,
    makeInvoiceDialog
  },
  props: {
    source: { type: String, required: true }, // source用来区分是未提交/审批中/审批完成三个页签
    configModel: { type: String, required: true, default: '190806' }
  },
  data() {
    return {
      canSendWeaver: false,
      context: new Context(),
      loading: false,
      billingPaymentHp: new BillingPaymentHp(this),
      documentManage: new DocumentManage(),
      activeTabName: '',
      customSearchItems: [],
      defaultSearchItems: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        applicationStatus: 1,
        simpleTriggerMode: false, // 是否为简单查询触发模式
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: ['voucherNoCreateDate', 'targetVoucherNo'] // 默认关联查询列条件
      },
      perConfigName: '',
      gridRefreshId: 0,
      gridParams: {},
      gridOptions: {
      },
      columnDefs: [],
      rowData: [],
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        ctx: new BillPayment(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      // 付款申请弹窗【查看明细】&【创建付款申请】
      billPaymentDetailProperties: {
        visible: false,
        title: '',
        uuid: '',
        state: -1,
        charges: [],
        chargesDirty: false,
        billPaymentDirty: false,
        inputBy: 0
      },
      // 创建付款申请 选择费用弹窗 accountId 结算单位代码 source来源 详情，创建 uuid 付款申请id
      createNewDialog: {
        visible: false,
        title: '',
        accountId: 0,
        source: 'addCharge',
        uuid: '',
        defaultConditions: -1
      },
      addChargeCondition: { // 点击加入费用按钮时传递的参数
        exceptKeys: [],
        hasBillPayment: -1,
        hasBilling: -1,
        oversea: -1,
        accountId: 0
      },
      showVerifiedAmount: true, // 是否显示已核销金额
      showRealClearingState: true, // 显示真实的核销状态
      showInvoiceNoColumn: true, // 是否显示对方发票号
      isCheckCharge: true, // 检查费用开票状态
      state: [], // 付款申请默认查询状态
      paidOff: -1, // 是否销账
      exceptKeys: [], // 在查询中想要例外的对象列表
      jobStates: [], // 业务状态
      selectedEntitiesForHedging: [], // 排除
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 5 // 开票方式:5-付款申请模块收票弹窗
      },
      location: LOG_BILL_PAYMENT.code
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        await this.initCustomSearchItems()
      }
    }
  },
  async created() {
    await this.billingPaymentHp.created()
    await ensureExecuteSuccess(() => this.defaultSearchItems && this.defaultSearchItems.length > 0)
    await this.initCustomSearchItems()
  },
  beforeMount() {
    this.billingPaymentHp.beforeMount()
  },
  mounted() {
  },
  methods: {
    async initCustomSearchItems() {
      const defaultSearchItems = []
      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchItems)
      }
      this.customSearchItems = defaultSearchItems
    },
    // 查询触发
    fetchData({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      if (simpleTriggerMode) {
        // 简单查询，则 combiConditions为string
        if (conditions !== null && conditions !== undefined) {
          const option = new AdvancedSearchOption(null, 'billPayment.BILLPAYMENTNO', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
          finallyConditions.push(option.formatObj2Json())
        }
      } else {
        // 高级查询条件组装
        const advConditions = lodash.cloneDeep(conditions)
        finallyConditions.push(...advConditions)
      }
      // 付款申请默认查询状态，根据页签来控制，每个页签查询的付款申请状态不同
      if (this.source === null || this.source === undefined) {
        const option = new AdvancedSearchOption(null, 'billPayment.STATE', [ClearingConstants.BILL_PAYMENT_NOT_COMMIT.code], AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      } else if (this.source === 'unSubmitted') {
        const option = new AdvancedSearchOption(null, 'billPayment.STATE', [ClearingConstants.BILL_PAYMENT_NOT_COMMIT.code], AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      } else if (this.source === 'approving') {
        const option = new AdvancedSearchOption(null, 'billPayment.STATE', [ClearingConstants.BILL_PAYMENT_COMMITED.code, ClearingConstants.BILL_PAYMENT_BIZ_APPROVED.code], AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      } else if (this.source === 'approved') {
        const option = new AdvancedSearchOption(null, 'billPayment.STATE', [ClearingConstants.BILL_PAYMENT_FINANCE_APPROVED.code, ClearingConstants.BILL_PAYMENT_PAID.code], AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 是否核销
      if (this.paidOff > -1) {
        const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', this.paidOff === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 查询关联外的列表数据
      if (this.exceptKeys.length > 0) {
        const option = new AdvancedSearchOption(null, 'billPayment.UUID', this.exceptKeys, AdvancedSearchConsts.OPERATOR_NOT_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 业务状态  思锐无需老的状态，需根据页签确定付款申请状态
      if (this.jobStates && this.jobStates.length > 0 && !LoadDefaultQueryParam.isSelectOption(finallyConditions, 'job.JOB_STATE')) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(this.job_states), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      } else if (!AdvancedSearchOption.hasField('job.JOB_STATE', finallyConditions)) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 是否排除某些数据
      if (this.selectedEntitiesForHedging && this.selectedEntitiesForHedging.length > 0) {
        const option = new AdvancedSearchOption(null, null, 'selectedEntitiesForHedging', this.selectedEntitiesForHedging)
        finallyConditions.push(option.formatObj2Json())
      }
      // 判断是否查询关联列数据
      if (this.showVerifiedAmount || this.showRealClearingState) {
        this.searchConditions.requires.push('writeoff')
      }
      if (this.showInvoiceNoColumn) {
        this.searchConditions.requires.push('invoiceNo')
      }
      if (this.isCheckCharge) {
        this.searchConditions.requires.push('checkCharge')
      }
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.searchConditions.simpleTriggerMode = simpleTriggerMode
      // 查询列表
      this.billingPaymentHp.doSearch()
    },
    // 分页组件查询
    queryPageHandler() {
      // 间接使用 查询按钮点击时的查询条件快照
      this.billingPaymentHp.doSearch()
    },
    // 双击列表查看详情
    rowDoubleClicked(row) {
      this.billingPaymentHp.viewBillPaymentDetail(true, row.data)
    },
    // 查看付款申请
    viewBillPaymentDetail() {
      this.billingPaymentHp.viewBillPaymentDetail(false, null)
    },
    // 【业务编号】列单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      // todo: 需要根据value装配this.templateSelectorDialog中相关内容
      const self = this
      if (!value) {
        self.$message.warning(`没有找到${value}对应的打印模板`)
      } else {
        this.templateSelectorDialog.data.JOB_UUID = [value]
        this.templateSelectorDialog.visible = true
      }
    },
    // 创建付款申请第一步
    createBillPayment() {
      this.billingPaymentHp.createBillPayment()
    },
    // 删除付款申请
    deleteBillPayment() {
      this.billingPaymentHp.deleteBillPayment()
    },
    // 提交付款申请
    commitBillPayment() {
      this.billingPaymentHp.commitBillPayment(1)
    },
    /**
     * 收票
     */
    collectInvoice() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      // 选择的数据是否存在可开票的账单
      let m = ''
      let flag = false
      for (let i = 0; i < rows.length; i++) {
        if (rows[i].notInvoiceByCharge === false) {
          if (m !== '') {
            m += ','
          }
          m = m + rows[i].billPaymentNo
        } else {
          flag = true
        }
      }
      if (m !== '' && flag) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OFCIIFPRNRN'))
        return
      } else if (m !== '' && !flag) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OFCIIFPRNRN'))
        return
      }
      // 调用公共收票功能
      this.makeInvoiceProperties.isAr = -1
      this.makeInvoiceProperties.isHedge = false
      this.makeInvoiceProperties.isSkipInvoiceFrom = false
      // 请求后台，返回开票界面的树状结构数据源以及相关基础属性
      const billPaymentKeys = Array.from(rows, p => p.uuid)
      this.makeInvoiceProperties.keys = billPaymentKeys
      this.makeInvoiceProperties.step = 'step1'
      this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
    },
    // 打印付款申请
    async printBillPayment() {
      await this.context.prepareData()
      const rows = getGridSelected(this.gridOptions)
      const billPaymentKeys = Array.from(rows, p => p.uuid)
      if (billPaymentKeys.length === 1) {
        this.$nextTick(async() => {
          // 每个页签的参数
          const params = {}
          params.category = 'BILLPAYMENT'
          // 公共参数
          params.BILLPAYMENT_UUID = rows[0].uuid
          params.BILL_PAYMENT_UUID = rows[0].uuid
          params.classNameType = SystemConstants.ACT
          console.log('---params--', params)
          this.templateSelectorDialog.ctx = new BillPayment(rows[0])
          this.templateSelectorDialog.category = params.category
          this.templateSelectorDialog.data = params
          // 组装打印回调函数
          await this.onPrintCallback()
          this.templateSelectorDialog.visible = true
        })
      } else if (billPaymentKeys.length > 0) {
        this.templateSelectorDialog.ctx = new BillPayment().fillDefaultValue().getData()
        this.templateSelectorDialog.category = 'BILLPAYMENT_LIST'
        this.templateSelectorDialog.data = { 'BILL_PAYMENT_UUID_LIST': billPaymentKeys, 'classNameType': SystemConstants.ACT }
        this.templateSelectorDialog.visible = true
      }
    },
    // 组装打印回调函数
    onPrintCallback() {
      this.prePrintCallback = null
      this.printedCallback = null
      this.v2CheckCallback = null
    },
    // 选择费用创建付款申请 下一步回调
    async nextCreateBillPaymentCallback(charges) {
      if (charges && charges.length > 0) {
        // 隐藏创建弹窗
        this.createNewDialog.visible = false
        // 展示详情弹窗
        this.billPaymentDetailProperties.visible = true
        this.billPaymentDetailProperties.uuid = ''
        this.billPaymentDetailProperties.title = '创建付款申请-详细信息'
        this.billPaymentDetailProperties.state = -1
        this.billPaymentDetailProperties.charges = charges
        this.billPaymentDetailProperties.chargesDirty = true
        this.billPaymentDetailProperties.billPaymentDirty = true
      }
    },
    // 创建付款申请第二步回退至第一步
    toPreStep() {
      this.billPaymentDetailProperties.visible = false
      this.billingPaymentHp.createBillPayment()
    },
    // 内部组件数据更新刷新列表数据 from 有值更新一条
    reflushRowData(from) {
      if (from !== undefined && from !== '') {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'billPayment.UUID', from, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
        this.billingPaymentHp.refreshOneBuyKey(conditions)
      } else {
        this.queryPageHandler()
      }
    },
    toPrint(command) {
      const chooseRows = this.gridOptions.api.getModel().rowsToDisplay.filter(node => node.selected).map(node => node.data)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      const params = {}
      const multiplePrint = chooseRows.length > 1 && command === this.$t('Clearing.PrintByPaymentRequestNumber') // 是否按照多个打印
      if (chooseRows.length === 1 || params.multiplePrint) {
        params.BILLPAYMENT_UUID = chooseRows[0].uuid
        params.BILL_PAYMENT_UUID = chooseRows[0].uuid
        if (multiplePrint) {
          params.multiplePrint = true
          params.multipleBillPaymentUuid = keys
        }
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT'
        this.templateSelectorDialog.visible = true
      } else {
        params.BILL_PAYMENT_UUID_LIST = keys
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT_LIST'
        this.templateSelectorDialog.visible = true
      }
    }
  }
}
</script>

<style lang="scss">
</style>
